// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__SgSnj","content":"RecentSearches_content__gv-vy"};